"use strict";

angular.module("vendor")
.controller("SectionHome", ["$scope", function($scope) {
}]);



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/home/home.controller.js
// module id = 974
// module chunks = 0